import React from 'react'
import Cookies from 'js-cookie';
import { app } from '../firebaseConfig';
import { getDatabase, ref, onValue, set, child, update, push, remove } from 'firebase/database';
import { useNavigate } from 'react-router-dom';
const ConfirmationPopUp = ({ handleConfirmPopUpState }) => {
    const db = getDatabase(app);
    const navigate = useNavigate();
    const deletProfileData = () => {
        // console.log("Delete Profile Data ", data);
        const userId = Cookies.get('userId');
        const userRef = ref(db, `users/${userId}`);
        remove(userRef).then(() => {
            // console.log('Data Deleted Sucessfully !!')
            deleteManeuverData();
            deleteRankingData();
            alert("Profile Deleted Successfully !!")
        }).catch((error) => {
            // console.log('Error in deleting data : ', error)
            alert("Failed to delete profile")
        })
    }

    const deleteRankingData = () => {
        const userRef = ref(db, `globalranking`);
        onValue(userRef, (snapshot) => {
            const dataset = snapshot.val();
            console.log("Printing dataset in profile ", dataset);
            Object.entries(dataset)?.forEach(([key, value]) => {
                value.rankings.forEach((item, index) => {
                    if (item.userID === Cookies.get('userId')) {
                        const itemRef = ref(db, `globalranking/${key}/rankings/${index}`);
                        remove(itemRef)
                            .then(() => {
                                // console.log('Data from profile is deleted successfully');
                            })
                            .catch(error => {
                                console.error("Error deleting data:", error);
                            });
                    }
                });
            });
        })
        // console.log("Printing user ranking data inside profile ", userRef);
    }

    const deleteManeuverData = () => {
        const userRef = ref(db, Cookies.get('userId'));
        remove(userRef).then(() => {
            console.log("Maneuver data deleted successfully ");
            Cookies.remove('userId');
            Cookies.remove('accessToken');
            navigate('/login')
        }).catch((error) => {
            console.log('Error in deleting data : ', error)
        })
    }


    return (
        <div class="fixed top-0 left-0 w-full h-full flex justify-center items-center">
            <div class="bg-white p-12 rounded-lg shadow-md">
                <p>Are you sure you want to delete your profile?
                    All your data will be permanently removed.</p>
                <div class="mt-4 flex justify-center">
                    <button class="bg-red-600 hover:bg-red-600 text-white font-semibold px-8 py-2 rounded mr-4" onClick={deletProfileData}>Yes</button>
                    <button class="bg-gray-600 hover:bg-gray-700 text-white font-semibold px-8 py-2 rounded ml-4" onClick={handleConfirmPopUpState}>No</button>
                </div>
            </div>
        </div>
    )
}

export default ConfirmationPopUp